module.exports = __webpack_public_path__ + "media/flags/rw-23704412.svg";